import { METRIC_GAP } from "../../components/Builder/Metrics";

export const getShapeMetric = (
  lineAlignment,
  canvasOffsetX1,
  canvasOffsetY1,
  currentShape,
  canvasTop,
  canvasLeft,
  canvasRight,
  canvasBottom,
  canvasOffsetX,
  canvasOffsetY
) => {
  let points;

  if (currentShape === "simple") {
    points = [
      {
        x: 0,
        y: -canvasOffsetY,
        width: canvasTop,
        height: canvasLeft,
        text: canvasTop,
        orientation: "horizontal",
        rotation: "top",
        degree: 180,
      },
      {
        x: -canvasOffsetX,
        y: 0,
        width: canvasTop,
        height: canvasLeft,
        text: canvasLeft,
        orientation: "vertical",
        rotation: "left",
        degree: 90,
      },
      ...(lineAlignment === "vertical" || lineAlignment === "split"
        ? [
            {
              x: 0,
              y: canvasLeft + canvasOffsetY1,
              width: canvasBottom,
              height: canvasLeft,
              text: canvasBottom,
              orientation: "horizontal",
              rotation: "bottom",
            },
            {
              x: canvasBottom,
              y: canvasLeft + canvasOffsetY1,
              width: canvasTop - canvasBottom,
              height: canvasLeft,
              text: canvasTop - canvasBottom,
              orientation: "horizontal",
              rotation: "bottom",
            },
          ]
        : []),
    ];
  } else if (currentShape === "left") {
    points = [
      {
        x: 0,
        y: -canvasOffsetY,
        width: canvasTop,
        height: 0,
        text: canvasTop,
        orientation: "horizontal",
        rotation: "top",
        degree: 180,
      },
      {
        x: -canvasOffsetX,
        y: 0,
        width: canvasTop,
        height: canvasLeft,
        text: canvasLeft,
        orientation: "vertical",
        rotation: "left",
        degree: 90,
      },
      {
        x: canvasTop + canvasOffsetX1,
        y: 0,
        width: canvasRight,
        height: canvasRight,
        text: canvasRight,
        orientation: "vertical",
        rotation: "right",
        degree: 270,
      },

      {
        x: canvasBottom,
        y: canvasRight,
        width:
          lineAlignment === "vertical" ? canvasTop - canvasBottom : canvasRight,
        height: canvasLeft - canvasRight,
        text:
          lineAlignment === "vertical"
            ? canvasTop - canvasBottom
            : canvasLeft - canvasRight,
        orientation: lineAlignment === "vertical" ? "horizontal" : "vertical",
        rotation: "bottom-right",
        degree: 90,
      },

      {
        x: 0,
        y: canvasLeft + canvasOffsetY1,
        width: canvasBottom,
        height: canvasLeft,
        text: canvasBottom,
        orientation: "horizontal",
        rotation: "bottom",
        degree: 0,
      },
    ];
  } else {
    points = [
      {
        x: 0,
        y: -canvasOffsetY,
        width: canvasTop,
        height: canvasLeft,
        text: canvasTop,
        orientation: "horizontal",
        rotation: "top",
        degree: 180,
      },

      {
        x: -(canvasOffsetX + 0),
        y: 0,
        width: canvasTop,
        height: canvasLeft,
        text: canvasLeft,
        orientation: "vertical",
        rotation: "left",
        degree: 90,
      },

      {
        x: canvasTop + canvasOffsetX1,
        y: 0,
        width: canvasTop,
        height: canvasRight,
        text: canvasRight,
        orientation: "vertical",
        rotation: "right",
        degree: 270,
      },

      {
        x: canvasBottom,
        y: canvasRight + canvasOffsetY1,
        width: canvasTop - canvasBottom,
        height: canvasRight,
        text: canvasTop - canvasBottom,
        orientation: "horizontal",
        degree: 0,
        rotation: "bottom",
      },

      {
        x: lineAlignment === "vertical" ? 0 : canvasBottom - METRIC_GAP,
        y: lineAlignment === "vertical" ? canvasLeft : canvasRight,
        width: canvasBottom,
        height: canvasLeft - canvasRight,
        text:
          lineAlignment === "vertical"
            ? canvasBottom
            : canvasRight - canvasLeft,
        orientation: lineAlignment === "vertical" ? "horizontal" : "vertical",
        rotation: "left",
        // degree: 90,
      },
    ];
  }

  return points;
};
